import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getProjectChallengeList = (params) => AxiosClient.get('/project-challenge', params);
const createProjectChallange = payload => AxiosClient.post('/project-challenge', payload);
const removeProjectChallenge = (projectChallengeId, payload) => AxiosClient.delete(`/project-challenge/${projectChallengeId}`, { data: payload });
const updateProjectChallenge = (projectChallengeId, payload) => AxiosClient.put(`/project-challenge/${projectChallengeId}`, { ...payload });

export {
    getProjectChallengeList,
    createProjectChallange,
    removeProjectChallenge,
    updateProjectChallenge
}